import { Link } from "gatsby";
import React from "react";
import { Box } from "../elements/Box";
import { Button } from "../elements/Button";
import { Flex } from "../elements/Flex";
import { Heading } from "../elements/Heading";
import { Text } from "../elements/Text";

const SectionHeader = ({
  textAlign = "center",
  title,
  subtitle,
  description,
  cta,
  path,
  color,
  my = 4,
  mt,
  mb,
  children,
}) => {
  const isString = (e) => typeof e === "string";

  return (
    <Flex
      flexDirection="column"
      maxWidth="800px"
      justifyContent="center"
      margin="0 auto"
      width="100%"
      textAlign={textAlign}
      color={color && "white"}
      my={my}
      mb={mb || my}
      mt={mt || my}
    >
      {!title ? null : isString(title) ? (
        <Heading fontSize={[28, null, 35]} textTransform="uppercase">
          {title}
        </Heading>
      ) : (
        title?.map((item, index) => (
          <Heading fontSize={[28, null, 35]} textTransform="uppercase" key={index}>
            {item}
          </Heading>
        ))
      )}

      {!subtitle ? null : (
        <Text mt={3} mb={4} fontSize={[18]}>
          {subtitle}
        </Text>
      )}

      {!description ? null : isString(description) ? (
        <Text mt={2}>{description}</Text>
      ) : (
        description?.map((item, index) => (
          <Text mt={2} key={index}>
            {item}
          </Text>
        ))
      )}

      {children}

      {cta && (
        <Link to={path}>
          <Button
            variant="rounded"
            bg={color ? "white" : "darkTeal"}
            color={color || "white"}
            display="inline-block"
            mt={[3, 3, 4]}
          >
            {cta}
          </Button>
        </Link>
      )}
    </Flex>
  );
};

export default SectionHeader;
